import React from 'react'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LayersIcon from '@mui/icons-material/Layers';
import { Link } from 'react-router-dom';
import {useStore} from '../utlis/customHooks/useStore';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import IconButton from '@mui/material/IconButton';
import ReplayIcon from '@mui/icons-material/Replay';

export default function Home() {
    const store = useStore()
    const [isNewStates, setIsNewStates] = React.useState()
    React.useEffect(()=> {
        if(Object.keys(store.state.firestore).length === 0) {
            store.fetchData()
        }
        else {
           // store.fetchData(false)
        }
        //store.fetchMarketData()
    }, [])

    return (
        <div className="px-5">
            <div className="flex flex-row justify-between mb-3">
                <span className="text-sm">Explore Instances<ArrowForwardIcon className="ml-1" style={{fontSize : '1.3em'}}/></span>
                <span className="text-sm mx-4 -mt-2">
                    <IconButton onClick={()=> {
                        store.fetchData(false)
                    }}>
                        <ReplayIcon style={{fontSize : '.8em'}}/>
                    </IconButton>
                </span>
            </div>
            <div className="flex flex-row flex-wrap">
                {Object.keys(store.state.firestore).reverse().map(key => (
                <div>
                <Link to={`instance/${key}`} className="relative mx-2 my-5 flex flex-col text-center ring-1 ring-gray-200 rounded-md p-6 pt-8 shadow-none dark:ring-gray-700 dark:bg-gray-900">
                    {store.state.firestore[key].isNew && <div className="absolute top-0 left-0 m-1">
                        <span className="mx-1 text-xs font-light dark:bg-gray-800 px-2 py-1 rounded bg-green-100 text-green-500 dark:text-gray-100">
                          New!
                        </span>
                    </div>}
                    <span className="text-blue-500"><LayersIcon style={{fontSize : '2em'}}/></span>
                    <span><span className="text-xs">Instance <span className="uppercase font-medium">{key.substring(0,4)}</span></span></span>
                    <span className="text-sm text-gray-400 mb-5">$ {parseInt(store.state.firestore[key].account)}</span>
                    <span className="text-sm text-gray-400 absolute bottom-0 left-0 m-2"> {store.state.firestore[key].instance_type === 'HISTORIC' ? (<>
                        <span><FiberManualRecordIcon className="text-gray-200" style={{fontSize : '1em'}}/> </span>
                        <span className="text-xs">Historic</span>
                    </>
                    ): (<>
                        <span><FiberManualRecordIcon className="text-green-600" style={{fontSize : '1em'}}/> </span>
                        <span className="text-xs">Live</span>
                        </>
                    )}
                    </span>
                    <div className="absolute bottom-0 right-0 m-2">
                        <span className="text-sm mt-3 text-green-600 dark:text-gray-500"><ArrowForwardIcon style={{fontSize : '1.3em', marginLeft : '3px'}}/></span>
                    </div>
                </Link>
            </div>
                ))}
            </div>
        </div>
    )
}
